import { FC } from 'react'
import { ReactComponent as TagIcon } from 'src/assets/svg/tabler_tag.svg'
import styles from './totalKeywordsCard.module.scss'

interface TotalKeywordsCardProps {
  activeCount?: number
  hasData?: boolean
  totalCount?: number
}

export const TotalKeywordsCard: FC<TotalKeywordsCardProps> = ({
  activeCount = 0,
  hasData = false,
  totalCount = 0,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <TagIcon className={styles.icon} />
        <h3 className={styles.title}>Total Keywords</h3>
      </div>
      {hasData ? (
        <div className={styles.content}>
          <div className={styles.mainValue}>{activeCount} Active</div>
          <div className={styles.subText}>out of {totalCount} total</div>
        </div>
      ) : (
        <div className={styles.noData}>No Data</div>
      )}
    </div>
  )
}
